export const getParams = (url, params) => {
  const searchParams = new URLSearchParams(url)

  const paramsObject = {}
  params.forEach(param => {
    paramsObject[param] = searchParams.get(param)
  }
  )
  return paramsObject
}